import $ from 'jquery';
import FLEX from 'FLEX/js/client-namespace';

if (!FLEX.isProd) {
	console.log('loaded', '/PANASONIC\t/js\t/components\t/component_nav\t/nav.js');
}

// Global Nav & Header behavior
function HoverTile($el) {
	console.log('/PANASONIC/\tcomponents/\tcomponent-hover-tile/\thover-tile.js', 'Nav()');

	var _$body = $('body');
	var _$document = $(document);
	var _$window = $(window);

	// Cache the body
	var $body = $('body');

	function bindEvents() {
		console.log('/PANASONIC/\tcomponents/\tcomponent-hover-tile/\thover-tile.js', 'bindEvents()');

		// Swap out main image with thumb on hover
		// Add pseudoelement styles for each carousel slide
		$('.slide', $el).each(function (index, el) {
			var thisSlideId = $(this).attr('data-section-id');
			var thisSlideThumbnailImage = $('.image-wrapper img', this).attr('src');

			// Add anchor link to entire element
			var anchorLink = $('a', this).attr('href');

			$(el).on('click', function () {
				if (typeof anchorLink !== 'undefined') {
					window.location.href = anchorLink;
				}
			});

			// Swaps out background for thumbnail on hover
			if (thisSlideThumbnailImage !== 'none' && typeof thisSlideThumbnailImage !== 'undefined') {
				$('<style>')
					.attr('id', 'dynamic-style')
					.html(`
						.component-background[data-section-id="${thisSlideId}"]::before {
						background-image: url(${thisSlideThumbnailImage});
						background-size: cover;
						background-position: center;
						content: "";
						position: absolute;
						top: 0; left: 0; right: 0; bottom: 0;
						opacity: 0;
						}
					`)
					.appendTo('head');
			}
		});		
	}

	this.init = function ($el) {
		console.log('/PANASONIC/\tcomponents/\tcomponent-hover-tile/\thover-tile.js', 'init()');
		bindEvents();

		return this;
	}

	return this.init($el);
}

export default HoverTile;
